import { render, staticRenderFns } from "./NewDContentPreview.vue?vue&type=template&id=6f34b9be&"
import script from "./NewDContentPreview.vue?vue&type=script&lang=js&"
export * from "./NewDContentPreview.vue?vue&type=script&lang=js&"
import style0 from "./NewDContentPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports